export enum CreditCardProcessingTechnologyCode {
    Website,
    InPersonMOTO,
    PointOfSale
}